import { CutterAudio } from '../../../state/entities/CutterAudio'
import { isAudioBufferChunk } from '../../functions/isAudioBufferChunk'
import { useCallback, useContext } from 'react'
import { CutterContext } from '../../contexts/CutterContext'

export function useCutReducedData() {
  const { audio } = useContext(CutterContext)
  return useCallback(
    (source: Float32Array, reducingFactor = 1) => cutReducedData(source, audio, reducingFactor),
    [audio],
  )
}

function cutReducedData(data: Float32Array, audio: CutterAudio, reducingFactor: number): Float32Array {
  const samples = new Float32Array(Math.ceil(audio.length * reducingFactor))
  audio.chunks.forEach((chunk) => {
    if (isAudioBufferChunk(chunk)) {
      const offsetReduced = Math.floor(chunk.offset * reducingFactor)
      const startReduced = Math.floor(chunk.start * reducingFactor)
      const lengthReduced = Math.floor(chunk.length * reducingFactor)
      samples.set(data.subarray(offsetReduced, offsetReduced + lengthReduced), startReduced)
    }
  })
  return samples
}
